import { useSelector } from 'react-redux'
import { useQuery } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'

import MissionSetupTabs from '@App/components/MissionSetupTabs/MissionSetupTabs'
import ActionBtn from '@App/components/ActionBtn/ActionBtn'
import DataSectionTitle from '@App/components/DataSectionTitle/DataSectionTitle'
import TypeToggles from '@App/components/TypeToggles/TypeToggles'
import SourceToggles from '@App/components/SourceToggles/SourceToggles'
import { fetchMissionDataSourcesByGroup, fetchMissionDataTypesByGroup } from '@services/data.service'

import { setSourceActiveNames, setEnvironmentActiveTypeIds } from '../mission-setup.slice'

import EnvironmentData from './EnvironmentData/EnvironmentData'

import './environment.styl'

function Environment() {
  const navigate = useNavigate()

  const { activeProject, sourcesActiveNames, environmentActiveTypeIds } = useSelector(state => state.missionSetup)

  const { data: sources } = useQuery({
    queryKey: ['sources', activeProject?.id, 'env'],
    queryFn: () => fetchMissionDataSourcesByGroup(activeProject?.id, 'env'),
  })

  const { data: types } = useQuery({
    queryKey: ['types', 'env', activeProject?.id],
    queryFn: () => fetchMissionDataTypesByGroup('env', activeProject?.id),
  })

  return (
    <div className="environment">
      <MissionSetupTabs />
      <hr />
      <div className="environment__action">
        <ActionBtn onClick={() => navigate('/mission-setup/environment/add')}>
          Add custom data
        </ActionBtn>
      </div>
      <hr />
      {sources && sources.length > 0
        ? (
            <>
              <DataSectionTitle>Types</DataSectionTitle>
              <TypeToggles
                types={types}
                activeTypeIds={environmentActiveTypeIds}
                setActiveTypeIds={setEnvironmentActiveTypeIds}
                badge={false}
              />
              <DataSectionTitle>Data source</DataSectionTitle>
              <SourceToggles
                sources={sources}
                sourcesActiveNames={sourcesActiveNames}
                setSourceActiveNames={setSourceActiveNames}
              />
              <EnvironmentData />
            </>
          )
        : (
            <p className="environment__no-data">
              No environment data for this mission.
            </p>
          )}
    </div>
  )
}

export default Environment
